import cryptoJs from './cryptoJs'

const B3StorageSchema = {
  B3RoleId: 'B3RoleId',
  B3CompanyId: 'B3CompanyId',
  B3UserId: 'B3UserId',
  B3B2BToken: 'B3B2BToken',
  B3Email: 'B3Email',
  B3CompanyStatus: 'B3CompanyStatus',
  B3CompanyName: 'B3CompanyName',
  B3AddressBookActionPermission: 'B3AddressBookActionPermission',
  B3AddressBookIsEnabled: 'B3AddressBookIsEnabled',
  B3ExtraFields: 'B3ExtraFields',
  B3IsInitDefaultAddresses: 'B3IsInitDefaultAddresses',
  B3CachedAddress: 'B3CachedAddress',
  B3PoNumber: 'B3PoNumber',
  B3FormCompanyName: 'B3FormCompanyName',
  B3PaymentsAdditionalTextFieldValue: 'B3PaymentsAdditionalTextFieldValue',
  quoteShippingMethods: 'quoteShippingMethods',
  B3OrderExtras: 'B3OrderExtras',
  B3BillingAddressExtras: 'B3BillingAddressExtras',
  B3ShippingAddressExtras: 'B3ShippingAddressExtras',
  B3DefaultAddressExtras: 'B3DefaultAddressExtras',
  B3QuoteLabel: 'B3QuoteLabel'
}

const clear = () => {
  Object.values(B3StorageSchema).forEach(field => {
    sessionStorage.removeItem(field)
  })
}

const getValue = function (this: any) {
  return cryptoJs.plainText(sessionStorage.getItem(this.name))
}

const setValue = function (this: any, value: string) {
  try {
    sessionStorage.setItem(this.name, cryptoJs.cipherText(value))
  } catch (error) {
    console.log(error)
  }
}

const removeValue = function (this: any) {
  sessionStorage.removeItem(this.name)
}

const mergeItemFunc = (obj: { name: string }) => ({
  ...obj,
  getValue: getValue.bind(obj),
  setValue: setValue.bind(obj),
  removeValue: removeValue.bind(obj),
})

const B3StorageFields = Object.entries(B3StorageSchema).reduce((result: any, [key, value]) => {
  result[key] = mergeItemFunc({
    name: value,
  })

  return result
}, {})

export default {
  clear,
  ...B3StorageFields,
}